<script setup lang="ts">

</script>

<template>
  <UMarquee :overlay="false" :repeat="8" :ui="{ root: '[--gap:--spacing(8)]', content: 'w-auto py-1' }"
            class="py-3 font-mono text-xs font-semibold border-b-2 border-primary">
    <div v-for="i in 4" class="flex gap-8">
      <span>Version alpha</span>
      <span>Été 2026</span>
    </div>
  </UMarquee>
</template>

<style scoped>

</style>
